'use strict';/* global define:false */define('modules/core/modules/app/services/app-state/index',['require','exports','module'],function(require,exports,module){'use strict';function service($window){// jshint validthis:true
// jshint latedef:false
var state;var states={};var REFRESH_STATE='refreshing';this.get=getState;this.set=setState;this.visited=visited;this.refresh=refresh;this.isRefreshing=isRefreshing;// ---
/**
     * Get current state
     *
     * @return {String} app state
     *
     * @tested
     */function getState(){return state;}/**
     * Set new app state
     *
     * @param {String} newState - new app state
     *
     * @tested
     */function setState(newState){if(state!==REFRESH_STATE){state=newState;states[newState]=1;}}/**
     * Bring app into refresh state
     *
     * @tested
     */function refresh(){state=REFRESH_STATE;$window.location.reload();}/**
     * Is app in refreshing state
     *
     * @return {Boolean} is app refreshing
     *
     * @tested
     */function isRefreshing(){return state===REFRESH_STATE;}function visited(state){var log=Object.keys(states);if(state){return!!~log.indexOf(state);}return log;}}module.exports=service;});
